import { useState, useEffect } from "react";

// This custom hook returns current user's network status (online/offline)
const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const statusChangeHandler = () => {
      setIsOnline(navigator.onLine); // Update network status
    };

    // Listen to the online status
    window.addEventListener("online", statusChangeHandler);

    // Listen to the offline status
    window.addEventListener("offline", statusChangeHandler);

    // Removing all event listeners for performance improvment
    return () => {
      window.removeEventListener("online", statusChangeHandler);
      window.removeEventListener("offline", statusChangeHandler);
    };
  }, [isOnline]);

  return isOnline;
};

export default useNetworkStatus;
